export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

export const getMetaTrackingData = () => {
  return {
    fbp: getCookie("_fbp"),
    fbc: getCookie("_fbc"),
    userAgent: navigator.userAgent,
    testEventCode: localStorage.getItem("meta_test_event_code") || null,
  };
};
